export { default } from './ImageMPCContainer';
